var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current)?_c('div',{staticClass:"laureatContainer"},_vm._l((_vm.randOrd),function(item,index){return _c('Laureat',{key:item.title + index,attrs:{"item":item,"index":index}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }